import APIService from 'services/APIService'

const api = APIService()

const organisationService = {
  getMine: () => api.get('/me/organisation'),
  getSuperAdmins: () => api.get('/me/organisation/super-admins'),
  addSuperAdmin: body => api.post('/me/organisation/super-admins', body),
  removeSuperAdmin: userId => api.delete(`/me/organisation/super-admins/${userId}`),
  withdrawInvitation: id => api.delete(`/me/organisation/super-admin-invitations/${id}`),
  getApprovers: () => api.get('/me/organisation/approvers'),
  setDomainApprovers: ({ domains, userIds }) => api.put('/me/organisation/approvers', { domains, user_ids: userIds }),
  checkApprovers: body => api.post('/me/organisation/approvers/check', body),
  giveApproverAccess: body => api.post('/me/organisation/approvers/give-access', body),
  getSharePointApprovers: ({ buildingPassportId, customViewId }) => api.get(`/building-passport/${buildingPassportId}/custom-views/${customViewId}/approvers`),
  setSharePointApprovers: ({ buildingPassportId, customViewId, userIds }) => api.put(`/building-passport/${buildingPassportId}/custom-views/${customViewId}/approvers`, { user_ids: userIds }),
  colleagues: q => api.get('/me/organisation/colleagues', { params: { q } }),
}

export default organisationService
